import React from 'react';
import { Box, Skeleton, SkeletonText, VStack } from '@chakra-ui/react';

const ServiceTypeSkeleton = () => {
  return (
    <Box textAlign="center" pt={10}>
      {/* Heading */}
      <SkeletonText noOfLines={1} skeletonHeight="6" width="200px" mx="auto" mb={6} />

      {/* Button Skeletons */}
      <VStack spacing={4}>
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton key={index} height="40px" width="280px" borderRadius="8px" />
        ))}
      </VStack>
    </Box>
  );
};

export default ServiceTypeSkeleton;
